import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  ModalFooter,
  Button,
} from 'reactstrap';

const CardBrandConfigurationsModal = ({
  brandCancelModal,
  setBrandCancelModal,
  completeBrandCancellation,
  checkedCardBrand,
}) => {
  const { t } = useTranslation(['review_changes', 'buttons']);

  return (
    <Modal isOpen={brandCancelModal} centered={true}>
      <ModalHeader>{t('revchn_card_brand_configurations_label')}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>
              {checkedCardBrand?.length > 1
                ? t('revchn_cancel_all_changes')
                : t('revchn_cancel_changes')}
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color='danger' onClick={() => completeBrandCancellation()}>
          {t('buttons:btn_yes')}
        </Button>
        <Button color='success' onClick={() => setBrandCancelModal(false)}>
          {t('buttons:btn_no')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CardBrandConfigurationsModal;
